import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import UITable from "components/UI/Table";
import DMTToggle from "components/UI/DMTToggle";
import widgetStyles from "css/widgets.module.css";
import SecondaryButton from "components/UI/Button/Secondary";
import FeatureRenderer from "components/Feature/RendererContainer";
import ReferencesModal from "components/FeePreferences/ReferencesModal";

const Container = styled.div.attrs({ className: "fee-pref-widget" })`
  & .header > * {
    margin: 0 50px 0 0;
  }
  & .header .type {
    font-weight: bold;
    width: 200px;
  }
  /* & .header .date {
    width: 145px;
  } */

  & .table td {
    max-width: 0;
  }

  .center {
    text-align: center;
  }

  .valign-middle {
    vertical-align: middle;
  }
`;

const FeePreferencesWidget = ({
  preferences,
  payType,
  type,
  feeDescriptions,
  feeReferences
}) => {
  const [reference, setReference] = useState("");
  
  const feeType =
    type.toLowerCase() === "registration" && payType
      ? `Registration (${payType})`
      : type;

  return (
    <Container className={widgetStyles.base}>
      {reference !== "" ? <ReferencesModal title={feeDescriptions[reference]} content={feeReferences[reference]} onClose={() => setReference("")} /> : null}
      <div className={`${widgetStyles.header} header`}>
        <span className="type">{feeType}</span>
        {/* <span className="date">Start Date: {startDate}</span> */}
        {/* <span className="date">End Date: {endDate}</span> */}
      </div>

      <UITable className="table">
        <UITable.Header>
          <UITable.Row>
            <UITable.HeaderCell>Fee Name</UITable.HeaderCell>
            <UITable.HeaderCell>Full/Prorate</UITable.HeaderCell>
            <UITable.HeaderCell>Active</UITable.HeaderCell>
            <FeatureRenderer feature="FeesReferences">
              <UITable.HeaderCell>References</UITable.HeaderCell>
            </FeatureRenderer>
          </UITable.Row>
        </UITable.Header>

        <UITable.Body>
          {preferences.map(preference => (
            <UITable.Row key={preference.feeName}>
              <UITable.Cell>
                {feeDescriptions
                  ? feeDescriptions[preference.feeName]
                  : preference.feeName}
                  &nbsp;<img className="valign-middle" src="/assets/images/icon-rounded-outline-info.png" title={preference.feeName}></img>
              </UITable.Cell>
              <UITable.Cell className="center">
                <DMTToggle
                  active={preference.payType === "Prorated"}
                  title="Change Pay Type"
                  onText="Prorated"
                  offText="Full"
                />
              </UITable.Cell>
              <UITable.ActionCell>
                <DMTToggle
                  active={preference.isEnabled}
                  title="Enable or disable fee"
                />
              </UITable.ActionCell>
              <FeatureRenderer feature="FeesReferences">
                <UITable.Cell>
                  {feeReferences && feeReferences[preference.feeName] ?
                    <center>
                      <SecondaryButton onClick={() => setReference(preference.feeName)}>
                        See References
                      </SecondaryButton>
                    </center>
                    :null}
                </UITable.Cell>
              </FeatureRenderer>
            </UITable.Row>
          ))}
        </UITable.Body>
      </UITable>
    </Container>
  );
};

FeePreferencesWidget.propTypes = {
  type: PropTypes.string.isRequired,
  // startDate: PropTypes.string.isRequired,
  // endDate: PropTypes.string.isRequired,
  preferences: PropTypes.arrayOf(
    PropTypes.shape({
      feeName: PropTypes.string.isRequired,
      payType: PropTypes.string.isRequired,
      isEnabled: PropTypes.bool.isRequired
    })
  ).isRequired,
  feeDescriptions: PropTypes.object
};

export default FeePreferencesWidget;
